import type { BusinessType } from '@festina/life-general-types/life'
import {
  useAuthenticationContext,
  useGetUserRoles,
} from '@festina-life/authentication'

import { useHook } from '../../lenteHooks'
import { useLazyAnnotations } from './useLazyAnnotations'
import { isAllowedToViewEntity } from './utils'

export const useLazyIsAllowedToViewEntity = () => {
  const { data: userRoles } = useGetUserRoles()
  const { shouldValidateAuthenticationHooks } = useAuthenticationContext()
  const fetchAnnotations = useLazyAnnotations()
  const tenantId = useHook('routing.tenant.useTenantParam')({
    isOptional: true,
  })

  return async ({
    overwriteInternalId,
    businessType,
  }: {
    overwriteInternalId?: string
    businessType: BusinessType
  }) => {
    if (!shouldValidateAuthenticationHooks) {
      return true
    }

    const annotations = await fetchAnnotations({
      overwriteInternalId,
      businessType,
    })
    return isAllowedToViewEntity({ annotations, tenantId, userRoles })
  }
}
